<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        News & Events
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>News & Events</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============News & Events========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>News & Events</h4>
                                <h2>Stay Updated, Stay Engaged</h2>
                                <p>Stay updated with the latest company news, industry insights, and upcoming events.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->
                <!-- mt-5  -->
                <div class="mt-5">
                    <!-- row  -->
                    <div class="row justify-content-start">
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let news of newsListArr; let i = index;">
                            <div class="post-card">
                                <div class="post-img news">
                                    <img [src]="news?.image" alt="Image not Found">
                                </div>
                                <div class="post-details news">
                                    <a [routerLink]="['/news-details', news?.id]" class="post-link">
                                        {{news?.title}}
                                    </a>
                                    <p class="shortDescription-content">
                                        {{news?.description}}
                                    </p>

                                    <div class="blog-card-footer py-2">
                                        <p class="date p-0 align-self-center">
                                            {{news?.publishDate}}
                                        </p>
                                        <a [routerLink]="['/news-details', news?.id]" class="more-btn align-self-center">read more</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- row end  -->
                </div>
                <!-- mt-5 end  -->
            </div>
        </div>
    </section>
    <!-- =============News & Events end ========== -->

</div>